'use strict';
const React = require('react');
const BaseComponent = require('../../shared/base');
let client = require('../../../../sdk/client');
let AddressModalComponent = require('../header/custom-address.jsx');
const toastr = require('toastr');

if (typeof window !== 'undefined'){
    require('../../../public/js/bepensa/jquery.auto-complete');
}

class CustomBottomHeader extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentExchange: "-"
        }
        this.Cookies_CurrentExchange = 'CurrentExchange';
    }

    exchangeCurrencyCallbackUpdate(
        strExchangeCurrency_I
    )
    {
        if(this.props.numExchangeCurrencyCallback != null){
            this.props.numExchangeCurrencyCallback(strExchangeCurrency_I);
        }
    }
    
    getCookie(name) {
        if(typeof window !== 'undefined'){
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
        }
    }

    getCurrentExchange(){
        var currentExchange = this.getCookie('CurrentExchange');
        if (currentExchange == undefined) {
            client.Exchange.getUSDCurrencyExchange()
                .then((exchange) => {
                    document.cookie = `CurrentExchange=${exchange}; path=/`;
                    this.setState({"currentExchange" : exchange});
                    this.exchangeCurrencyCallbackUpdate(exchange);
                },
                (error) => {
                    toastr.info("Tipo de cambio no recuperado, los precios pueden no estar actualizados.");
                    this.setState({"currentExchange": process.env.DEFAULT_CURRENCY_VALUE});
                    this.exchangeCurrencyCallbackUpdate(process.env.DEFAULT_CURRENCY_VALUE);
                    console.log(error);
                }
            );
        } else {
            this.setState({"currentExchange" : currentExchange});
            this.exchangeCurrencyCallbackUpdate(currentExchange);
        }
    }

    componentDidMount(){
        this.getCurrentExchange();
        //Listeners
        $('.header-search-box input').focusin(function(){
           $('.header-content-box div').addClass('bp-transparent');
        });

        $('.header-search-box input').focusout(function(){
           $('.header-content-box div').removeClass('bp-transparent');
        });

        //Typeahead listener
        this.subInitAutoComplete();
        if (this.props.user === undefined || this.props.user.Guest === true){
            $('#custom-address-modal-header').css('display', 'none')
            
            $('.icon-address-header').css('visibility', 'hidden')
        }else{
            $('.icon-address-header').css('display', 'none')
        }
    }

    subInitAutoComplete(){
        let self = this;
        $("#bp-search-box").autoComplete({
            //The delay in milliseconds between when a keystroke occurs and when a search is performed.
            delay: 400,
            cache: true,
			minChars: 2,
			source: function(term, suggest) {
                var data = {
                    strKeyword : term
                };
				var strApiUrl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.CUSTOM_SEARCH + "/BPSimpleSearch_service.php";
				$.ajax({
					url: strApiUrl,
					contentType: "application/json",
					type: 'POST',
                    data: JSON.stringify(data),
					success: function(result) {
						//console.log(result);
                        var jsonResult = JSON.parse(result);
						var darrSearchedData = [];
						for (var intIndex = 0; intIndex < jsonResult.Records.length; intIndex++) {
                            //                              //Flag to determine if this item is an Offer 
                            var boolIsOffer = false;

							//								//To easy code.
							var item = jsonResult.Records[intIndex];
							var strItemName = item.Name;
							var strId = item.ID;
							var strSKU = item.SKU;
                            
                            var partCode = "NA";
                            var cpls = "NA";
                            var motors = "NA";
                            var boolIsSupercesor = false;
                            var strSupercesor = "";
                            if(item.CustomFields != null && item.CustomFields.length > 0){
                                //partCF = item.CustomFields.find(cf => cf.Name == "Número de Parte");
                                item.CustomFields.forEach(function(cf, index){
                                    if(cf.Name == "Número de Parte"){
                                        partCode = cf.Values[0];
                                    }
                                    else if(cf.Name == "CPL"){
                                        cpls = cf.Values[0];
                                    }
                                    else if(cf.Name == "Motor"){
                                        motors = cf.Values[0];
                                    }
                                    else if(cf.Name == "Supercesor"){
                                        strSupercesor = cf.Values[0];
                                    }

                                    if (
                                        partCode != "NA" && partCode != "" && 
                                        partCode.trim() == strSupercesor.trim()
                                        )
                                    {
                                        boolIsSupercesor = true;
                                    }
                                });
                            }

                            var categories = "";
                            if(item.Categories != null && item.Categories.length > 0){
                                item.Categories.forEach(function(category, index){
                                    categories += category.Name;
                                    if(index != item.Categories.length - 1){
                                        categories += ", ";
                                    }
                                    
                                    if(category.Name == "Ofertas"){
                                        boolIsOffer = true;
                                    }
                                });
                            }
                            else{
                                categories = "Todas las categorías";
                            }

                            var strImage = "";
                            if(item.Media != null && item.Media.length > 0){
                                strImage = item.Media[0].MediaUrl;
                            }
                            else{
                                strImage = process.env.STR_IMAGE;
                            }

							var objItem = {
								strName: strItemName,
								strId: strId,
								strSKU: strSKU,
                                strPartCode: partCode,
                                strCPLs:cpls,
                                strMotors:motors,
                                strCategories:categories,
                                strImage: strImage,
                                boolIsOffer: boolIsOffer,
                                boolIsSupercesor: boolIsSupercesor
							};
                            
							darrSearchedData.push(objItem);
						}

						suggest(darrSearchedData);
					}
				});
			},
			renderItem: function(item, search) {
				var obj = item;
                var strClass = obj.boolIsOffer ? "autocomplete-offert" : "hide";
                var strCplClass = obj.strCPLs ? "" : "hide";
                var strAntecesorStyle = !obj.boolIsSupercesor ? "color:blue;" : "color:blue;";
                return (
                '<div class="autocomplete-suggestion" data-itemname="' + obj.strName.replace("\"","") + '" data-itemid="' + obj.strId + '" ' +
					'data-itemsku="' + obj.strSKU + '" data-val="' + search + '">' +
                    '<div style="display:grid;">' +
                        '<img alt="" src="/assets/images/bepensa/oferta.png" class="' + strClass + '"></img>' +
                        '<img alt="" src="' + obj.strImage +'"></img>' +
                    '</div>' +
                    '<div class="autocomplete-text">' +
                        '<strong style="font-size:12px;margin-left:2px;">' + obj.strPartCode + '&nbsp;-&nbsp;</strong>' +
                        '<label>' + obj.strName + '</label>' +
                        '<div class="autocomplete-p">' +
                            '<p>Motor(es):&nbsp<strong>' + obj.strMotors + '</strong></p>' +
                            '<p>Categoría(s):&nbsp<strong>' + obj.strCategories + '</strong></p>' +
                        '</div>' +
                        '<p class="' + strCplClass + '">CPL:&nbsp<strong>' + obj.strCPLs + '</strong></p>' +
                        '<p style="' + strAntecesorStyle + '"><strong>Parte Antecesora</strong></p>' +
                    '</div>' +
				'</div>'
                );
			},
			onSelect: function(e, term, item) {
                var itemName = item.data('itemname');
                var itemId = item.data('itemid');
                let href = self.itemUrl(itemName, itemId);
                //console.log(itemId + "/" + itemName + " : " + href);
                window.location.href = href;
			}
		});
    }

    itemUrl(itemName, itemId) {
        return "/items/" + this.generateSlug(itemName) + "/" + itemId;
    }

    generateSlug(itemName) {
        return itemName.replace(/[^a-zA-Z0-9\-]/g, "");
    }

    onKeyDown(e) {
        if (e.keyCode == 13) {
            this.gotoSearch(e);
        }
    }

    gotoSearch(e) {
        //                                                  //Trigger blur event to auto-complete control.
        $( "#bp-search-box" ).trigger( "click" ); 
        $( "#bp-search-box" ).autoComplete("destroy");
        const keyword = $('.header-search-box input').val();
        let params = [];
        params.push('keywords=' + encodeURIComponent(keyword));
        window.location.href = '/search?' + params.join('&');
    }

    render() {
        var showlabelCummins = 'none';
        var headerInHome = 'header-NotinHome';
        if (window && window.location && window.location.pathname == "/") {
            showlabelCummins = 'flex';
            headerInHome = 'header-inHome';
        }
       return (
            <div suppressHydrationWarning={true} className={"header-content-box " + headerInHome}>
                <div suppressHydrationWarning={true} className="header-exchange-currency" id="header-exchange-currency-mobile">
                    <div id="label-info-exchange-currency-mobile">
                        <label>Tipo de cambio</label>&nbsp;
                        <label>$ 1 USD = </label>&nbsp;<label id="exchange-currency" currency = {this.state.currentExchange}>$ {this.state.currentExchange}</label>&nbsp;<label>MXN</label>
                    </div>
                    <div className="label-info-home" id="label-info-home-mobile" suppressHydrationWarning={true} style={{display: showlabelCummins}}>
                        <label suppressHydrationWarning={true}>
                        ¡Bienvenidos a una nueva experiencia de compra con Megamak Cummins test 10 Julio!
                        </label>  
                        {/*
                        <label>
                        Envíos gratis a partir de compras de $200,000.
                        </label>
                        */} 
                    </div>
                    {/* <div>
                       <label>$1 USD = </label>&nbsp;<label id="exchange-currency" currency = {this.state.currentExchange}>{this.state.currentExchange}</label>&nbsp;<label>MXN</label>
                   </div>*/}
                </div>
                <div className="icon-address-header">
                    <img alt="" src="/assets/images/bepensa/icon-address.svg"></img>
                </div>
                <div className="custom-address-modal" id="custom-address-modal-header">
                    <AddressModalComponent user={this.props.user}></AddressModalComponent>
                </div>
                <div id="search-header-container">
                    <div className="header-exchange-currency">
                        <div>
                            <label>Tipo de cambio: </label> &nbsp;
                            <label>$1 USD = </label>&nbsp;<label id="exchange-currency" currency = {this.state.currentExchange}>$ {this.state.currentExchange}</label>&nbsp;<label>MXN</label>
                        </div>
                    </div>
                    <div className="header-search-box" id="input-search-container">
                        <input 
                                id="bp-search-box"
                                type="text"
                                placeholder="Escribe un número de parte, palabra clave, motor o CPL"
                                defaultValue={this.props.keyword}
                                onKeyDown={(e) => this.onKeyDown(e)}></input>
                            <img 
                                src='/assets/images/bepensa/ic_search_svg.svg'
                                onClick={(e) => this.gotoSearch(e)}
                                alt=""></img>
                    </div>
                </div>   
            </div>
        )
    }
}

module.exports = CustomBottomHeader;